import { render } from "./privacy.vue?vue&type=template&id=7a06f1ce&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=7a06f1ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a06f1ce"]])

export default __exports__